const FORBIDDEN_TAGS = new Set(["SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "LINK", "META"]);

const hasUnsafeProtocol = (value: string) => {
	const normalized = value.trim().toLowerCase();
	return normalized.startsWith("javascript:");
};

export const sanitizeHtml = (html: string) => {
	if (!html) return "";

	if (typeof document === "undefined") {
		return html
			.replace(/<\s*(script|style|iframe|object|embed|link|meta)[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, "")
			.replace(/<\s*(script|style|iframe|object|embed|link|meta)[^>]*\/?>/gi, "")
			.replace(/\s+on[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
			.replace(/\s+style\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
			.replace(/\s+(href|src|xlink:href)\s*=\s*("\s*javascript:[^"]*"|'\s*javascript:[^']*'|\s*javascript:[^\s>]+)/gi, "");
	}

	const template = document.createElement("template");
	template.innerHTML = html;

	const elements = Array.from(template.content.querySelectorAll("*"));
	elements.forEach((element) => {
		if (FORBIDDEN_TAGS.has(element.tagName)) {
			element.remove();
			return;
		}

		Array.from(element.attributes).forEach((attribute) => {
			const name = attribute.name.toLowerCase();
			const value = attribute.value || "";

			if (name.startsWith("on") || name === "style") {
				element.removeAttribute(attribute.name);
				return;
			}

			if ((name === "href" || name === "src" || name === "xlink:href") && hasUnsafeProtocol(value)) {
				element.removeAttribute(attribute.name);
			}
		});
	});

	return template.innerHTML;
};
